var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargedBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0_2_7655)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2_7655",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_7655",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_7655",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACSklEQVR4nO3by27TQBTG8VkhkZk0W2BF4SUKC25v1FKUOc2CJX0DKE/C/S24PAAICdhAK7Wb44NGQkgtdhQ7xmPH/580q1qj+MvJycSdcQ4AAAAAAAAAAAAAkJ8Xu++jPvdRP3rRkyCFjWl40ZM/937k53av9YC3FnYziL7NfaOhd0Nfzxa23UrI04Xd9qI/8t9U0cvhRb9Po91aK+TZ3K77qN9y30zo+UiFmD71jYMOUd/kvokwlBH1XaOQ/dweZH/xMqzR6AsyrS4q3rlTL7Y72bcrbmQmB3bVR9tLGZQGHfVZ7Ul91E+lk4ntupHzYg/Ls9EP9SeLelw22Rgr+aKUQUXQv1xdVX2o9kQbKrSVD0EvR9CbHnTupVXouMURtBA0FV2G1rF+Puf/pl+86KF7bJdqT7TK9WPu0aF8rX1Ye6JVrifo4kIG+pWgO6jof4qVil6OoKXfPZqKromghYpmeSe0jtpoHULroHUIraO71hH1c+2JVrmen+DF+WcdUZ8Q9H+taJ7eNdLaU0Nax3IELf1Z3nU70YYKBN0Ngh5a0GkfWdlE7L1z7vIju1b6/8CoP9vbTRptz43cJNp+e7tJRY8qfkKeprDTXmE3xv3Rkrbs6llF0E8bHXXL/TM6DG3M7U6jdzBEfZX9xctARtQXrilOZRUrn8qaRbvh1pHO0KWzdNkrRvo50vHA6YHtrBXy38pe2DZtpCgJWl+mT71rWxC7m04epWVM1RmXTR4+6rGP+j6tLhp/8QEAAAAAAAAAAAAAAMD11W8J7+j0YEXOSwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargedBattery);
export default __webpack_public_path__ + "static/media/ChargedBattery.31db38fd3d063aff267eb224d9374a5d.svg";
export { ForwardRef as ReactComponent };